var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 248 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1416_553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.115 78.991H87.0912L99.6157 1.54883H119.639L107.115 78.991Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.704 3.44155C175.755 1.87462 169.49 0.144531 161.744 0.144531C141.97 0.144531 128.045 10.6893 127.96 25.7651C127.795 36.888 137.929 43.066 145.509 46.7747C153.256 50.5645 155.889 53.0381 155.889 56.4161C155.811 61.6042 149.629 63.9956 143.864 63.9956C135.87 63.9956 131.586 62.7627 125.076 59.8763L122.44 58.6389L119.638 76.023C124.334 78.1626 132.987 80.0613 141.97 80.1446C162.981 80.1446 176.659 69.763 176.821 53.6972C176.901 44.8815 171.55 38.1265 160.013 32.6066C153.01 29.0632 148.721 26.674 148.721 23.0485C148.803 19.7525 152.348 16.3767 160.254 16.3767C166.764 16.2113 171.547 17.7761 175.17 19.3419L176.981 20.1642L179.704 3.44155Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.318 51.556C207.967 47.107 214.313 29.8883 214.313 29.8883C214.229 30.0536 215.958 25.3572 216.947 22.4741L218.347 29.147C218.347 29.147 222.139 47.6841 222.962 51.556C219.833 51.556 210.273 51.556 206.318 51.556ZM231.035 1.54883H215.547C210.77 1.54883 207.142 2.94823 205.081 7.97423L175.338 78.9899H196.348C196.348 78.9899 199.807 69.4317 200.551 67.3731C202.856 67.3731 223.295 67.3731 226.26 67.3731C226.835 70.092 228.649 78.9899 228.649 78.9899H247.19L231.035 1.54883Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3663 1.54883L50.7561 54.3569L48.6132 43.6468C44.9877 31.2888 33.6173 17.862 20.9286 11.1858L38.8908 78.9088H60.0657L91.5402 1.54883H70.3663Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5464 1.54883H0.329591L0 3.11357C25.1311 9.54007 41.775 25.0309 48.6132 43.6501L41.6096 8.05855C40.4566 3.11247 36.9132 1.71198 32.5464 1.54883Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1416_553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247.19,
    height: 80,
    fill: "white",
    transform: "translate(0 0.144531)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.e160509a3ed0cee52b99c46c56f39c22.svg";
export { ForwardRef as ReactComponent };